import React, { useEffect, useState } from 'react';
import './GallerySection.css';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';

const GallerySection = () => {
  const { t } = useTranslation();
  const [images, setImages] = useState([]);
  const [lightboxIndex, setLightboxIndex] = useState(-1);
  const [clickedIndex, setClickedIndex] = useState(null);

  useEffect(() => {
    const imageContext = require.context('./images', false, /\.(jpe?g|png|webp)$/);
    const keys = imageContext.keys();

    const loadImageMetadata = (src, fileName) =>
      new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = () => {
          resolve({
            src,
            width: img.naturalWidth,
            height: img.naturalHeight,
            title: fileName.replace(/\.[^/.]+$/, '').replace(/[-_]/g, ' '), // format name
          });
        };
      });

    Promise.all(
      keys.map((key) => {
        const src = imageContext(key);
        const fileName = key.replace('./', '');
        return loadImageMetadata(src, fileName);
      })
    ).then(setImages);
  }, []);

const settings = {
  dots: true,
  infinite: true,
  speed: 300,              // reduce transition duration (default is 300ms)
  swipeToSlide: true,      // allow quicker swiping between slides
  touchThreshold: 10,      // lower this to make swiping more responsive
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
};

  const handleClick = (index) => {
    setClickedIndex(index);
    setTimeout(() => setClickedIndex(null), 200);
    setLightboxIndex(index);
  };

  return (
    <section id="gallery" className="gallery-section">
      <h2>{t('gallery.title')}</h2>

      {/* Desktop Grid */}
      <div className="gallery-grid desktop-only">
        {images.map((img, index) => (
          <div key={index} className="gallery-item" onClick={() => handleClick(index)}>
            <img
              src={img.src}
              alt={img.title}
              loading="lazy"
              className={clickedIndex === index ? 'clicked' : ''}
            />
          </div>
        ))}
      </div>

      {/* Mobile Carousel */}
      <div className="mobile-only">
        <Slider {...settings}>
          {images.map((img, index) => (
            <div key={index} onClick={() => handleClick(index)}>
              <img
                src={img.src}
                alt={img.title}
                className={`carousel-image ${clickedIndex === index ? 'clicked' : ''}`}
                loading="lazy"
              />
            </div>
          ))}
        </Slider>
      </div>

      {/* Lightbox */}

      <Lightbox
        open={lightboxIndex >= 0}
        close={() => setLightboxIndex(-1)}
        slides={images}
        index={lightboxIndex}
        plugins={[Zoom]}
        zoom={{
          maxZoomPixelRatio: 5, // allow zooming up to 5x native resolution
          zoomInMultiplier: 2,  // how fast each pinch/gesture increases zoom
          doubleTapDelay: 300,
          doubleTapZoom: 2,     // 2x zoom on double-tap
          scrollToZoom: true,
        }}
        styles={{
          image: {
            width: 'auto',
            height: 'auto',
            maxWidth: 'none',
            maxHeight: 'none',
            objectFit: 'contain',
          },
        }}
      />




    </section>
  );
};

export default GallerySection;
